import { useEffect } from 'react';
import { invalidateMappingLogs } from 'actions/auto-mapping';

const useLogic = () => {
  useEffect(() => {
    invalidateMappingLogs();
  }, []);
};

export default useLogic;
